export default __webpack_public_path__ + "static/media/1805048_ZR_003_Dr_Robert_Witt-e1557857999378.adfd85bc.jpg";